<template>
    <div style="height: 600px; width: 800px">
        <el-dialog
                :title="$t('competitors.header')"
                :visible.sync="dialogVisible"
                width="50%"
                :before-close="handleClose"
                center>
            <el-dialog
                    width="40%"
                    :visible.sync="innerVisible"
                    append-to-body>
                <el-main>
                    <el-form ref="competitorForm" :model="$data.deviceParams" label-width="30%" :rules="$data.rules">
                        <el-form-item :label="$t('competitors.editForm.fieldFio')" prop="label">
                            <el-input
                                    :placeholder="$t('competitors.editForm.placeHolder.fieldFio')"
                                    v-model="$data.deviceParams.label"
                                    clearable
                                    style="width: 80%">
                            </el-input>
                        </el-form-item>
                        <el-form-item :label="$t('competitors.editForm.fieldPhone')" prop="phone">
                            <el-input
                                    :placeholder="$t('competitors.editForm.placeHolder.fieldPhone')"
                                    v-model="$data.deviceParams.phone"
                                    clearable
                                    style="width: 80%">
                            </el-input>
                        </el-form-item>
                    </el-form>
                </el-main>
                <el-footer align="right" style="margin-top: 5px">
                    <el-button @click="handleSave" type="primary">{{$t('competitors.buttonSave')}}</el-button>
                    <el-button @click="handleCancel">{{$t('competitors.buttonCancel')}}</el-button>
                </el-footer>
            </el-dialog>
            <el-table
                    width="100%"
                    height="500px"
                    :data="devices"
                    :empty-text="$t('common.emptyText')"
                    @row-dblclick="handleDeviceSelected">
                <el-table-column
                        type="index"
                        width="40">
                </el-table-column>
                <el-table-column
                        prop="label"
                        :label="$t('competitors.competitorGrid.columnFio')">
                </el-table-column>
                <el-table-column
                        prop="phone"
                        :label="$t('competitors.competitorGrid.columnPhone')">
                </el-table-column>
                <el-table-column
                    align="right">
                    <template slot-scope="scope">
                        <el-tooltip :content="$t('competitors.competitorGrid.eventDeleteCompetitor')" placement="top" effect="light">
                            <el-button
                                    icon="el-icon-delete"
                                    type="text"
                                    size="medium"
                                    @click="handleDeleteDevice(scope.row)"
                            ></el-button>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <el-footer align="right" style="margin-top: 5px">
                <el-button @click="handleShow" type="primary">{{$t('competitors.buttonCreate')}}</el-button>
                <el-button @click="handleClose">{{$t('competitors.buttonCancel')}}</el-button>
            </el-footer>
        </el-dialog>
    </div>
</template>

<script>
    import {getDevices, createDevice, updateDevice} from "../../api/device";
    import Utils from '@/utils';

    export default {
        name: "DeviceListModal",
        props: {
            dialogVisible: {
                type: Boolean,
                default: false
            },
            data: {
                type: Object,
                default: function () {
                    return {};
                }
            }
        },
        data() {
            return {
                devices: [],
                innerVisible: false,
                deviceParams: {
                    id: null,
                    label: null,
                    phone: null
                },
                rules: {
                    label: [
                        {required: true, message: 'Please input FIO', trigger: 'change'}
                    ],
                    phone: [
                        {
                            required: true,
                            pattern: /^(\+7|7|8)?[\s\-]?\(?[489][0-9]{2}\)?[\s\-]?[0-9]{3}[\s\-]?[0-9]{2}[\s\-]?[0-9]{2}$/gm,
                            message: 'Please input phone number',
                            trigger: 'change'
                        }
                    ]
                }
            };
        },
        mounted: function () {
            this.doDiveces();
        },
        methods: {
            handleClose: function () {
                this.$emit("visible-change", false);
            },
            frameLoaded: function () {
                console.log('Frame with Competitors is loaded');
            },
            handleDeviceSelected: function (data) {
                this.deviceParams.id = data.id;
                this.deviceParams.label = data.label;
                this.deviceParams.phone = data.phone;
                this.innerVisible = true;
            },
            handleNewDevice: function () {
                this.deviceParams = this.createNewDevice();
                this.innerVisible = true;
            },
            handleDeleteDevice: function(row) {
                this.$confirm('Вы действительно хотите удалить спортсмена "' + row.label + '"?', 'Внимание!', {
                    confirmButtonText: 'Да',
                    cancelButtonText: 'Нет',
                    center: true,
                    type: 'warning'
                }).then(() => {
                    this.loading = true;
                    row.deleted = true;
                    updateDevice(row).then(response => {
                        this.loading = false;
                        this.$message({
                            type: 'success',
                            message: 'Спортсмен ' + row.label + ' удален!'
                        });
                        this.doDiveces();
                    }).catch(error => {
                        this.$message({
                            type: 'error',
                            message: 'Возникла ошибка при удалении спортсмена ' + row.label + '! ' + error.toString()
                        });
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Удаление отменено!'
                    });
                });
            },
            handleCancel: function () {
                this.deviceParams.id = null;
                this.deviceParams.label = null;
                this.deviceParams.phone = null;
                this.resetForm('competitorForm');
                this.innerVisible = false;
            },
            handleShow: function () {
                if(this.devices != null && this.devices  != undefined && this.devices .length > 20) {
                    Utils.showMessage(this, this.$t('competitors.restrictionHeader'), this.$t('competitors.restrictionMessage'));
                    return;
                }
                this.deviceParams.id = null;
                this.deviceParams.label = null;
                this.deviceParams.phone = null;
                this.innerVisible = true;
            },
            doDiveces: function () {
                this.loading = true;
                getDevices().then(response => {
                    this.devices = response;
                }).finally(() => {
                    this.loading = false;
                });
            },
            handleSave: function () {
                this.validateForm('competitorForm');
            },
            validateForm: function (formName) {
                let _this = this;
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.loading = true;
                        console.log('Try save: ' + JSON.stringify(_this.deviceParams));
                        let devicePromis;
                        if (_this.deviceParams.id == undefined || _this.deviceParams.id == null) {
                            devicePromis = createDevice(_this.deviceParams);
                        } else {
                            devicePromis = updateDevice(_this.deviceParams);
                        }
                        devicePromis.then(response => {
                            this.innerVisible = false;
                            this.doDiveces();
                        }).catch(error => {
                            console.log(error.toString());
                        });
                    } else {
                        Utils.showMessage(this, "Ошибка ввода данных", "Проверьте правильность введенных данных");
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            }
        }
    }
</script>

<style scoped>
    .ipc-input-label {
        display: inline-block;
        width: 80px;
    }
</style>
